import React from "react";
import { Image, Spin } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import Masonry from "react-masonry-css";
import { Trans } from "@lingui/react/macro";
import ApiService from "../../../services/ApiService";
import { ASSET_URL } from "../../../config";

const imageStyles = `
.tr-galerie__images {
    max-width: 1180px;
    margin: 24px auto 48px;
    padding: 0 16px;
}
.tr-galerie__img {
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    display: block;
    box-shadow: 0 2px 10px rgba(0,0,0,.06);
    transition: transform .25s ease, box-shadow .25s ease;
    cursor: pointer;
}
.tr-galerie__img:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(0,0,0,.12);
}
.tr-galerie__empty {
    text-align: center;
    padding: 64px 16px;
    color: #6b7280;
    font-size: 15px;
}
.tr-galerie__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px 0;
}
.tr-masonry-grid { display: flex; margin-left: -14px; width: auto; }
.tr-masonry-grid_column { padding-left: 14px; background-clip: padding-box; }
.tr-masonry-grid_column > * { margin-bottom: 14px; }
`;

export default class ImageRender extends React.Component {

    state = {
        data: [],
        loading: false,
        page: 0,
        finished: false,
    };

    componentDidMount() {
        this.setState({ loading: true }, () => {
            this.getData(true);
        });
    }

    async getData(init = false) {
        let page = this.state.page + 1;
        if (init) page = 1;

        this.setState({ loading: true });
        const res = await ApiService.get("/galeries/images/" + this.props.galerie.id + "/" + page);

        const finalData = init ? res.data : [...this.state.data, ...res.data];
        const finished = res.data.length < 10;

        this.setState({
            loading: false,
            data: finalData,
            page,
            finished,
        });
    }

    render() {
        return (
            <div>
                <style dangerouslySetInnerHTML={{ __html: imageStyles }} />

                {!this.state.loading && this.state.data.length === 0 && (
                    <div className="tr-galerie__empty">
                        <Trans>Aucune photo dans cette galerie pour le moment.</Trans>
                    </div>
                )}

                {this.state.data.length > 0 && (
                    <div className="tr-galerie__images">
                        <Image.PreviewGroup>
                            <InfiniteScroll
                                dataLength={this.state.data.length}
                                next={() => this.getData()}
                                hasMore={!this.state.finished}
                                loader={<div className="tr-galerie__loader"><Spin spinning /></div>}
                                style={{ overflow: "visible" }}
                            >
                                <Masonry
                                    breakpointCols={{ default: 3, 1100: 3, 750: 2, 350: 1 }}
                                    className="tr-masonry-grid"
                                    columnClassName="tr-masonry-grid_column"
                                >
                                    {this.state.data.map((image, i) => (
                                        <Image
                                            key={i}
                                            src={ASSET_URL + "/" + image}
                                            className="tr-galerie__img"
                                        />
                                    ))}
                                </Masonry>
                            </InfiniteScroll>
                        </Image.PreviewGroup>
                    </div>
                )}
            </div>
        );
    }
}
